import { uiNotify } from '../../../catalog/app/redux/modules/ui/actions'

export const dataRefresh = () => (dispatch) => {

  const language = window.ferrero ? window.ferrero.locale : "es_ES";

    dispatch(uiNotify({ text: 'Refreshing data...'}))    

    const ES_URL = `/api/es/admin/refreshData`;
    const PT_URL = `/api/pt/admin/refreshData`;
  
    fetch(language === "es_ES" ? ES_URL : PT_URL, {
      method: "GET",
      headers: {
        Accept: "application/json;odata=verbose",
      },
    })
    .then((response) => {

      response.status == 200 && response.json()
        .then(data => {

          dispatch(uiNotify({ text: 'Catalog data refreshed'}))
        })
    })
    .catch(err => {
      dispatch(uiNotify({
        text: error
      }))
    })  
  
  };
  
  export const REFRESH_CATALOG_DATA = "REFRESH_CATALOG_DATA";

  export const freshData = () => ({
    type: REFRESH_CATALOG_DATA,
    payload: {
      data: data,
    },
  });


  export const getUsersList = () => (dispatch) => {

    const language = window.ferrero ? window.ferrero.locale : "es_ES";
  
      dispatch(uiNotify({ text: 'Loading users list data...'}))    
  
      const ES_URL = `/api/es/admin/getUsers`;
      const PT_URL = `/api/pt/admin/getUsers`;
    
     return fetch(language === "es_ES" ? ES_URL : PT_URL, {
        method: "GET",
        headers: {
          Accept: "application/json;odata=verbose",
        },
      })
      .then((response) => {
        
        return response.status == 200 && response.json()
        
        .then(data => {
                
          dispatch(uiNotify({ text: 'Users data loaded'}))
        
          return dispatch({
              type: USERS_LIST_HYDRATE,
              payload: {
                data: data,
              },
            })
          })
      })
      .catch(err => {
        dispatch(uiNotify({
          text: error
        }))
      })  
    
    };
    
    export const USERS_LIST_HYDRATE = "USERS_LIST_HYDRATE";


  
    export const updateUser = (data) => (dispatch) => {

      const language = window.ferrero ? window.ferrero.locale : "es_ES";
      
      dispatch(uiNotify({ text: "Loading data..." }));
    
      const ES_URL = `/api/es/admin/updateUserData`;
      const PT_URL = `/api/pt/admin/updateUserData`;
    
      return fetch(language === "es_ES" ? ES_URL : PT_URL, {
        method: "POST",
        headers: {
          Accept: "application/json;odata=verbose",
          'Content-Type': 'application/json'
    
        },
        body: JSON.stringify(data)
      })
        .then((res) => res.json())
    
        .then((data) => {
          dispatch(uiNotify({ text: "User updated" }));
    
          return dispatch({
            type: UPDATE_USER,
            payload: {
              data: data,
            },
          });
        })
    
        .catch((error) => {
          console.log(error);
          dispatch(
            uiNotify({
              text: error,
            })
          );
          return dispatch(error);
        });
      };
      
      export const UPDATE_USER = "UPDATE_USER";


        
    export const deleteUser = (id) => (dispatch) => {

      const language = window.ferrero ? window.ferrero.locale : "es_ES";
      
      dispatch(uiNotify({ text: "Loading data..." }));
    
      const ES_URL = `/api/es/admin/deleteUser/${id}`;
      const PT_URL = `/api/pt/admin/deleteUser/${id}`;
    
      return fetch(language === "es_ES" ? ES_URL : PT_URL, {
        method: "POST",
        headers: {
          Accept: "application/json;odata=verbose",
          'Content-Type': 'application/json'
    
        },
      })
        .then((res) => res.json())
    
        .then((data) => {
          dispatch(uiNotify({ text: "User deleted" }));
    
          return dispatch({
            type: DELETE_USER,
            payload: {
              data: data,
            },
          });
        })
    
        .catch((error) => {
          console.log(error);
          dispatch(
            uiNotify({
              text: error,
            })
          );
          return dispatch(error);
        });
      };
      
      export const DELETE_USER = "DELETE_USER";



export const USER_CREATED = "USER_CREATED";

export const createUser = (data) => (dispatch) => {

  const language = window.ferrero ? window.ferrero.locale : "es_ES";
  
  dispatch(uiNotify({ text: "Loading data..." }));

  const ES_URL = `/api/es/admin/createUser`;
  const PT_URL = `/api/pt/admin/createUser`;

  return fetch(language === "es_ES" ? ES_URL : PT_URL, {
    method: "POST",
    headers: {
      Accept: "application/json;odata=verbose",
      'Content-Type': 'application/json'

    },
    body: JSON.stringify(data)
  })
    .then((res) => res.json())

    .then((data) => {
      dispatch(uiNotify({ text: "User created" }));

      return dispatch({
        type: USER_CREATED,
        payload: {
          data: data.catalogs,
        },
      });
    })

    .catch((error) => {
      console.log(error);
      dispatch(
        uiNotify({
          text: error,
        })
      );
      return dispatch(error);
    });
};